import React, { useState } from "react";
import { connect } from "react-redux";
import swal from "sweetalert";
import { app } from "../../constants/config";
import {
  deletingLandlord,
  updatingLandlord,
} from "../../actions/LandlordActions";
import $ from "jquery";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";

const DisplayLandlords = (props) => {
  const [ActiveLandlord, setActiveLandlord] = useState({
    id: "",
    bankId: "",
    linker: "",
    name: "",
    description: "",
    createdAt: "",
    updatedAt: "",
  });

  const [Deleting, setDeleting] = useState(false);
  const [Editting, setEditting] = useState(false);

  const saveEdittedLandlord = () => {
    if (/\S/.test(ActiveLandlord.name)) {
      setEditting(true);
      fetch(`${app}/landlord/edit`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          Authorization: `Bearer ${props.banker.token}`,
        },
        body: JSON.stringify({
          ...ActiveLandlord,
          LandlordId: ActiveLandlord.id,
        }),
      })
        .then((res) => res.json())
        .then((details) => {
          setEditting(false);
          $("#editLandlord").modal("hide");
          if (details.code != 2) {
            props.updatingLandlord(details);
          } else {
            swal({
              title: "Server Error!",
              text: "Please try again",
              icon: "error",
              timer: 3000,
            });
          }
        })
        .catch((err) => {
          setEditting(false);
          swal({
            title: "Connection Error!",
            text: "Check your connection and try again",
            icon: "error",
            timer: 3000,
          });
        });
    } else {
      swal({
        title: "Empty Name!",
        text: "Ensure name is filled",
        icon: "error",
        timer: 3000,
      });
    }
  };

  const saveDeletedLandlord = () => {
    setDeleting(true);
    fetch(`${app}/landlord/delete`, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        Authorization: `Bearer ${props.banker.token}`,
      },
      body: JSON.stringify({
        ...ActiveLandlord,
        LandlordId: ActiveLandlord.id,
      }),
    })
      .then((res) => res.json())
      .then((details) => {
        setDeleting(false);
        $("#deleteLandlord").modal("hide");
        if ((details.code = 2)) {
          props.deletingLandlord(details.linker);
        } else {
          swal({
            title: "Server Error!",
            text: "Please try again",
            icon: "error",
            timer: 3000,
          });
        }
      })
      .catch((err) => {
        setDeleting(false);

        swal({
          title: "Connection Error!",
          text: "Check your connection and try again",
          icon: "error",
          timer: 3000,
        });
      });
  };

  const LandlordsDisplay = props.Landlords.map((Landlord) => (
    <tr>
      <td>{Landlord.name}</td>
      <td>{Landlord.description}</td>

      {/* <td>
        <button
          className="btn-sm btn-info rounded-pill"
          onClick={() =>
            props.history.push(`/portal/landlord/payment/${Landlord.id}`)
          }
        >
          Payments
        </button>
        </td>*/}
      <td>
        <button
          className="btn-sm btn-info rounded-pill"
          onClick={() =>
            props.history.push(`/portal/landlord/buildings/${Landlord.id}`)
          }
        >
          Buildings
        </button>
      </td>
      <td>
        {" "}
        <button
          className="btn-sm btn-primary rounded-pill"
          onClick={() => setActiveLandlord({ ...Landlord })}
          data-toggle="modal"
          data-target="#editLandlord"
        >
          <FontAwesomeIcon className="mx-2" icon={faEdit} />
        </button>
      </td>
      <td>
        <button
          className="btn-sm btn-danger rounded-pill"
          onClick={() => setActiveLandlord({ ...Landlord })}
          data-toggle="modal"
          data-target="#deleteLandlord"
        >
          <FontAwesomeIcon className="mx-2" icon={faTrash} />
        </button>
      </td>
    </tr>
  ));

  return (
    <>
      <div style={{ width: "100%", overflowX: "scroll" }}>
        <table className="table table-bordered table-sm">
          <thead>
            <tr>
              <th scope="column">Name</th>
              <th scope="column">Details</th>
              {/*<th scope="column">Payments</th>*/}
              <th scope="column">Buildings</th>
              <th scope="column">Edit</th>
              <th scope="column">Delete</th>
            </tr>
          </thead>
          {LandlordsDisplay}
        </table>
      </div>

      <div
        id="editLandlord"
        className="modal fade"
        onClick={(e) => e.stopPropagation()}
        style={{ zIndex: 5000 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="text-center capitalize">
                Edit {ActiveLandlord.name} Landlord
              </h5>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 col-6 text-center">
                <div className="card card-primary">
                  <div>
                    <label>Landlord Name :</label>
                    <input
                      type="text"
                      className="rounded-pill form-control"
                      placeholder="Enter Landlord Name"
                      value={ActiveLandlord.name}
                      onChange={(e) =>
                        setActiveLandlord({
                          ...ActiveLandlord,
                          name: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div>
                    <label>Landlord Description :</label>
                    <input
                      type="text"
                      className="rounded-pill form-control"
                      placeholder="Enter Landlord Description"
                      value={ActiveLandlord.description}
                      onChange={(e) =>
                        setActiveLandlord({
                          ...ActiveLandlord,
                          description: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-12 d-flex justify-content-around my-4">
                <button
                  className="btn-xs btn-danger rounded-pill"
                  data-dismiss="modal"
                >
                  Cancel
                </button>
                {!Editting ? (
                  <button
                    className="btn-xs btn-primary rounded-pill"
                    onClick={() => saveEdittedLandlord()}
                  >
                    Save
                  </button>
                ) : (
                  <span className="spinner-border text-primary"></span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        id="deleteLandlord"
        className="modal fade"
        onClick={(e) => e.stopPropagation()}
        style={{ zIndex: 5000 }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header justify-content-center">
              <h5 className="text-center capitalize">
                Delete {ActiveLandlord.name} Landlord
              </h5>
            </div>
            <div className="row justify-content-center">
              <div className="col-12 d-flex justify-content-around my-4">
                <button
                  className="btn-xs btn-danger rounded-pill"
                  data-dismiss="modal"
                >
                  Cancel
                </button>

                {!Deleting ? (
                  <button
                    className="btn-xs btn-warning rounded-pill"
                    onClick={() => saveDeletedLandlord()}
                  >
                    Delete
                  </button>
                ) : (
                  <span className="spinner-border text-primary"></span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  banker: state.auth.banker,
  Landlords: state.Landlord.Landlords,
});

export default connect(mapStateToProps, {
  deletingLandlord,
  updatingLandlord,
})(withRouter(DisplayLandlords));
